import React, { useEffect, useState } from "react";
import html2canvas from "html2canvas";

function Templates() {
  const [templates, setTemplates] = useState([]);
  const [musicas, setMusicas] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [form, setForm] = useState({});
  const [editandoId, setEditandoId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [paginaAtual, setPaginaAtual] = useState(1);
const itensPorPagina = 10;


const totalPaginas = Math.ceil(templates.length / itensPorPagina);

const inicio = (paginaAtual - 1) * itensPorPagina;
const fim = inicio + itensPorPagina;

const templatesPaginados = templates.slice(inicio, fim);

  useEffect(() => {
    listarTemplates();
    listarMusicas();
    listarCategorias();
  }, []);

  // LISTAR
  const listarTemplates = () => {
    fetch("https://videooferta.com/api/listar_templates.php", { method: "POST" })
      .then(res => res.json())
      .then(data => setTemplates(data));
  };

  const listarMusicas = () => {
    fetch("https://videooferta.com/api/listar_musicas.php", { method: "POST" })
      .then(res => res.json())
      .then(data => setMusicas(data));
  };

  const listarCategorias = () => {
    fetch("https://videooferta.com/api/listar_categorias.php", { method: "POST" })
      .then(res => res.json())
      .then(data => setCategorias(data));
  };

  // HANDLE CHANGE
  function handleChange(e) {
    const { name, value, files } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  }

  // SALVAR / ATUALIZAR
  async function salvar(e) {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("titulo", form.titulo || "");
    formData.append("categoria_id", form.categoria_id || "");
    formData.append("musica_id", form.musica_id || "");
    formData.append("cor_texto", form.cor_texto || "#000000");
    formData.append("cor_etiqueta", form.cor_etiqueta || "#000000");
    formData.append("bg_etiqueta", form.bg_etiqueta || "#ffffff");
    formData.append("fonte", form.fonte || "");

    if (form.selo instanceof File) formData.append("selo", form.selo);
    if (form.background instanceof File) formData.append("background", form.background);

    const preview = document.getElementById("preview-tema");

    if (preview) {
      const canvas = await html2canvas(preview, { useCORS: true, allowTaint: false, backgroundColor: null });
      canvas.toBlob(blob => {
        if (blob) formData.append("thumbnail", blob, "thumbnail.jpg");
        enviarFormulario(formData);
      }, "image/jpeg", 0.8);
    } else {
      enviarFormulario(formData);
    }
  }

  function enviarFormulario(formData) {
    const url = editandoId
      ? "https://videooferta.com/api/editar_template.php"
      : "https://videooferta.com/api/cadastrar_template.php";

    if (editandoId) formData.append("id", editandoId);

    fetch(url, { method: "POST", body: formData })
      .then(res => res.json())
      .then(data => {
        if (data.status === "ok") {
          alert(data.msg);
          setForm({});
          setEditandoId(null);
          listarTemplates();
          listarCategorias();
        } else {
          alert("Erro: " + data.msg);
        }
      })
      .finally(() => setLoading(false));
  }

  // EDITAR
  const editar = t => {
    setEditandoId(t.id);
    setForm({
      titulo: t.titulo,
      categoria_id: t.categoria_id,
      musica_id: t.musica_id,
      cor_texto: t.cor_texto || "#000000",
      cor_etiqueta: t.cor_etiqueta || "#000000",
      bg_etiqueta: t.bg_etiqueta || "#ffffff",
      fonte: t.fonte || "",
      background: t.background || null,
      selo: t.selo || null,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="row">
      {/* LISTAGEM */}
      <div className="col-4">
        <h6>Temas</h6>
        <table className="table table-sm table-bordered small">
          <thead>
            <tr>
              <th>ID</th>
              <th>Título</th>
              <th>Categoria</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {templatesPaginados.map(t => (
              <tr key={t.id}>
                <td>{t.id}</td>
                <td>{t.titulo}</td>
                <td>{t.categoria_id}</td>
                <td>
                  <button className="btn btn-sm btn-warning me-1" onClick={() => editar(t)}>Editar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="d-flex justify-content-between align-items-center mt-2">
  <button
    className="btn btn-sm btn-secondary"
    disabled={paginaAtual === 1}
    onClick={() => setPaginaAtual(p => p - 1)}
  >
    Anterior
  </button>

  <span className="small">
    Página {paginaAtual} de {totalPaginas}
  </span>

  <button
    className="btn btn-sm btn-secondary"
    disabled={paginaAtual === totalPaginas}
    onClick={() => setPaginaAtual(p => p + 1)}
  >
    Próxima 
  </button>
</div>

      </div>

      {/* FORM */}
      <div className="col-4 small">
        <h6>{editandoId ? "Editar Template" : "Cadastrar Template"}</h6>

        <form onSubmit={salvar}>
          <div className="mb-2">
            <label>Título</label>
            <input className="form-control" name="titulo" onChange={handleChange} value={form.titulo || ""} />
          </div>

          <div className="mb-2">
            <label>Categoria</label>
            <select className="form-control" name="categoria_id" onChange={handleChange} value={form.categoria_id || ""}>
              <option value="">Selecione</option>
              {categorias.map(c => <option key={c.id} value={c.id}>{c.titulo}</option>)}
            </select>
          </div>

          <div className="mb-2">
            <label>Música</label>
            <select className="form-control" name="musica_id" onChange={handleChange} value={form.musica_id || ""}>
              <option value="">Selecione</option>
              {musicas.map(m => <option key={m.id} value={m.id}>{m.titulo}</option>)}
            </select>
          </div>

          <div className="mb-2">
            <label>Selo</label>
            <input type="file" className="form-control" name="selo" onChange={handleChange} />
          </div>

          <div className="mb-2">
            <label>Background</label>
            <input type="file" className="form-control" name="background" onChange={handleChange} />
          </div>

          {/* CORES */}
          <div className="row mb-3">
            <div className="col-4">
              <label>Texto</label>
              <input type="color" className="form-control form-control-color w-100"
                name="cor_texto" value={form.cor_texto || "#000000"} onChange={handleChange} />
            </div>
            <div className="col-4">
              <label>Etiqueta</label>
              <input type="color" className="form-control form-control-color w-100"
                name="cor_etiqueta" value={form.cor_etiqueta || "#000000"} onChange={handleChange} />
            </div>
            <div className="col-4">
              <label>BG Etiqueta</label>
              <input type="color" className="form-control form-control-color w-100"
                name="bg_etiqueta" value={form.bg_etiqueta || "#ffffff"} onChange={handleChange} />
            </div>
          </div>

          <button className="btn btn-primary w-100" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                {editandoId ? "Atualizando..." : "Salvando..."}
              </>
            ) : (
              editandoId ? "Atualizar Template" : "Salvar Template"
            )}
          </button>
        </form>
      </div>

      {/* PREVIEW */}
      <div className="col-4">
        <h6>Preview</h6>
        <div
        className="preview-tema"
          id="preview-tema"
          style={{
            position: "relative",
            width: "100%",
            aspectRatio: "9 / 16",
            maxWidth: 270,
            backgroundColor: "#000",
            overflow: "hidden",
          }}
        >
          {form.background && (
            <img
              src={form.background instanceof File ? URL.createObjectURL(form.background) : form.background}
              crossOrigin="anonymous"
              alt="Background"
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )}
          {form.selo && (
            <img
              src={form.selo instanceof File ? URL.createObjectURL(form.selo) : form.selo}
              crossOrigin="anonymous"
              style={{ maxWidth: "70%", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
              alt="Selo"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Templates;
